import type { ReactNode } from "react";

// A quiet title that stays at the top while its part of the list scrolls by. A line inset like the panel's padding
// separates it from the part above, as in the search's results.
export const HaNResultListHeader = ({ title, children }: { title: string; children?: ReactNode }) => {
  return (
    <div className="sticky top-0 z-10 flex items-center justify-between bg-white py-2 px-5 text-sm text-mapiq-black-500 [&:not(:first-child)]:pt-5 [&:not(:first-child)]:mt-2 [&:not(:first-child)]:border-t">
      <h4 className="text-mapiq-black-500 ">{title}</h4>

      {children}
    </div>
  );
};
